(function () {
  // Fix for assets/theme.js's compare_price() module: on the mobile-only
  // duplicate price block (.variant-1-product-section.desktop-hide.mobile-only),
  // its crossed-out "regular" price element gets set to the sale price instead
  // of the regular price on every variantchange event (including the one that
  // fires automatically on page load and on every swatch/variant switch), so
  // mobile visitors see no discount at all until something else happens to
  // touch that element.
  //
  // Rather than patching the minified bundle directly, this mirrors the true
  // desktop block's crossed-out price (which theme.js sets correctly) onto
  // the mobile duplicate whenever it changes, so the two can never disagree.
  //
  // IMPORTANT: '.price__sale .price-item--regular' unqualified matches BOTH
  // the mobile-only duplicate and the true desktop element, and the mobile
  // one happens to come first in DOM order - so each lookup below explicitly
  // excludes/includes the mobile-only ancestor rather than relying on
  // document order.
  var MOBILE_SCOPE = '.variant-1-product-section.desktop-hide.mobile-only';

  function getDesktopReg() {
    var all = document.querySelectorAll('.price__sale .price-item--regular');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest(MOBILE_SCOPE)) return all[i];
    }
    return null;
  }

  function getMobileReg() {
    return document.querySelector(MOBILE_SCOPE + ' .price__sale .price-item--regular');
  }

  function sync() {
    var desktopReg = getDesktopReg();
    var mobileReg = getMobileReg();
    if (!desktopReg || !mobileReg) return;
    if (mobileReg.innerHTML !== desktopReg.innerHTML) {
      mobileReg.innerHTML = desktopReg.innerHTML;
    }
  }

  function init() {
    var desktopReg = getDesktopReg();
    if (!desktopReg) return;
    sync();
    new MutationObserver(sync).observe(desktopReg, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
